<!-- @component The layout for mdsvex files. Cannot use TypeScript processing here. -->
<script context="module">
  import CopyPageButton from "$lib/ui/docs/CopyPageButton.svelte";
  import a from "./a.svelte";
  import img from "./img.svelte";
  import pre from "./pre.svelte";
  import table from "./table.svelte";

  export { a, img, pre, table };
</script>

<script>
  import Content from "$lib/ui/docs/Content.svelte";
  import Outline from "$lib/ui/docs/Outline.svelte";

  /** @type {import('@stefanprobst/remark-extract-toc').Toc} */
  export let toc;

  /** @type {string} */
  export let rawContent;

  // Extracted from frontmatter of .svx files
  export let crossLinksText;
  export let crossLinks;

  /** @type {Set<string>} */
  let activeHeadings;
  let cliArgs;
</script>

<Content bind:activeHeadings bind:cliArgs>
  <div class="docs-copy-button">
    <CopyPageButton source={rawContent} page="docs-cli" />
  </div>

  <article>
    <slot />
  </article>
</Content>

<Outline {toc} {activeHeadings} {cliArgs} {crossLinks} {crossLinksText} />

<style lang="postcss">
  article {
    @apply text-c-gray-80 text-base pb-6 mx-auto break-words;
  }
  article :global(h1) {
    /* pt-10 -mt-10 fixes click-to-scroll-to */
    @apply text-4xl font-medium text-white leading-tight tracking-tight mt-10 mb-8 scroll-mt-20 clear-left md:clear-none;
  }
  article :global(h2) {
    @apply text-2xl font-medium text-c-gray-90 leading-snug mt-10 mb-5 scroll-mt-20;
  }
  article :global(h3) {
    @apply text-xl font-medium text-c-gray-80 leading-snug mt-8 mb-5 scroll-mt-20;
  }
  article :global(h4) {
    @apply text-lg font-medium text-c-gray-80 leading-snug my-5 scroll-mt-20;
  }

  article :global(:not(h1, h2, h3, h4) > code) {
    @apply text-sm;
  }

  article :global(:not(pre) > code) {
    @apply bg-c-gray-5 border border-c-gray-10 rounded py-0.5 px-1;
  }

  article :global(p) {
    @apply my-5;
  }

  article :global(hr) {
    @apply w-2/3 mx-auto my-6 border-c-gray-20;
  }

  article :global(strong) {
    @apply text-white font-bold;
  }

  article :global(ul) {
    @apply pl-7 my-4 list-disc;
  }

  article :global(ul li)::marker {
    @apply text-c-gray-30;
  }

  article :global(ol) {
    @apply pl-7 my-4 list-decimal;
  }

  article :global(ol li)::marker {
    @apply text-c-gray-60;
  }

  article :global(li) {
    @apply pl-1.5 mb-2;
  }

  article :global(blockquote) {
    @apply px-4 py-1 border-l-4 border-c-gray-20;
  }

  article :global(blockquote > p) {
    @apply leading-relaxed;
  }
</style>
